type Coords = { latitude: number; longitude: number };

export function withDistance<
  T extends { latitude?: string | null; longitude?: string | null },
>(stores: Array<T>, origin: Coords): Array<T & { distance?: number }> {
  return stores.map((store) => {
    const lat = parseFloat(store.latitude ?? '');
    const lon = parseFloat(store.longitude ?? '');
    const distance =
      isFinite(lat) && isFinite(lon)
        ? getDistanceKm(origin, { latitude: lat, longitude: lon })
        : undefined;
    return { ...store, distance };
  });
}

export function sortByDistance<T extends { distance?: number }>(
  items: Array<T>,
): Array<T> {
  return [...items].sort((a, b) => {
    if (a.distance == null && b.distance == null) return 0;
    if (a.distance == null) return 1;
    if (b.distance == null) return -1;
    return a.distance - b.distance;
  });
}

// Haversine formula — returns distance in km between two coordinates.
export function getDistanceKm(a: Coords, b: Coords): number {
  const R = 6371;
  const dLat = ((b.latitude - a.latitude) * Math.PI) / 180;
  const dLon = ((b.longitude - a.longitude) * Math.PI) / 180;
  const lat1 = (a.latitude * Math.PI) / 180;
  const lat2 = (b.latitude * Math.PI) / 180;

  const x =
    Math.sin(dLat / 2) ** 2 +
    Math.sin(dLon / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);

  return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
}
